import { ScrollBlocker } from "./scroll_blocker";

export class Popup {
    constructor(options = {}) {
        this._element = jQuery(options.selector);
        this.bindDismiss(options.dismiss);
    }

    bindDismiss(selectors = []) {
        jQuery(selectors.join(','), this._element).on('click', () => {
            this.Hide();
        })
    }

    Hide() {
        this._element.removeClass('show');
        ScrollBlocker.RemoveFrom('body');
    }

    Show() {
        this._element.addClass('show');
        ScrollBlocker.AddTo('body');
    }

    GetElement() {
        return this._element;
    }

    static setup(options = {}) {
        return new Popup(options)
    }
}